/*
 *
 * Email reducer
 *
 */
import { produce } from "immer";

import {
  // INDIVIDUAL
  TEMPLATE_INDIVIDUAL_START_LISTING,
  TEMPLATE_INDIVIDUAL_SET_LISTING,
  TEMPLATE_INDIVIDUAL_SET_LISTING_ERROR,
  // ALL TEMPLATES
  TEMPLATE_START_LISTING,
  TEMPLATE_SET_LISTING,
  TEMPLATE_SET_LISTING_ERROR,
  // ADD
  TEMPLATE_ADD_SUBMIT,
  TEMPLATE_ADD_SUCCESS,
  TEMPLATE_ADD_FAILURE,
  // SAVE
  TEMPLATE_SAVE_SUCCESS,
  TEMPLATE_SAVE_FAILURE,
  //FILTER
  TEMPLATE_GET_FILTER_DATA,
  TEMPLATE_GET_FILTER_DATA_SUCCESS,
  TEMPLATE_GET_FILTER_DATA_FAILURE,
  //EDIT
  TEMPLATE_SET_EDIT_TEMPLATE,
  TEMPLATE_EDIT_SUBMIT,
  TEMPLATE_EDIT_SUCCESS,
  TEMPLATE_EDIT_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingTemplates: false,
  isSavingTemplate: false,
  isAddingTemplate: false,
  isEditingTemplate: false,
  templates: [],
  isFetchingFilters: false,
  filters: {},
  currentFilter: {},
  currentTemplate: {},
  isSubmitting: false,
};

const emailReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // INDIVIDUAL
      case TEMPLATE_INDIVIDUAL_START_LISTING:
        draft.isFetchingTemplates = true;
        break;
      case TEMPLATE_INDIVIDUAL_SET_LISTING:
        draft.currentTemplate = action.payload;
        draft.isFetchingTemplates = false;
        break;
      case TEMPLATE_INDIVIDUAL_SET_LISTING_ERROR:
        draft.isFetchingTemplates = false;
        break;
      // GET ALL
      case TEMPLATE_START_LISTING:
        draft.isFetchingTemplates = true;
        break;
      case TEMPLATE_SET_LISTING:
        draft.templates = action.payload;
        draft.isFetchingTemplates = false;
        break;
      case TEMPLATE_SET_LISTING_ERROR:
        draft.isFetchingTemplates = false;
        break;
      // ADD TEMPLATE
      case TEMPLATE_ADD_SUBMIT:
        draft.isSubmitting = true;
        break;
      case TEMPLATE_ADD_SUCCESS:
        draft.isAddingTemplate = true;
        break;
      case TEMPLATE_ADD_FAILURE:
        draft.isAddingTemplate = false;
        break;
      // EDIT TEMPLATE
      case TEMPLATE_SET_EDIT_TEMPLATE:
        draft.isEditingTemplate = true;
        draft.currentTemplate = action.payload;
        break;
      case TEMPLATE_EDIT_SUBMIT:
        draft.isSubmitting = true;
        break;
      case TEMPLATE_EDIT_SUCCESS:
        draft.currentTemplate = null;
        draft.isSubmitting = false;
        break;
      case TEMPLATE_EDIT_FAILURE:
        draft.isSubmiting = false;
        break;
      // SAVE TEMPLATE
      case TEMPLATE_SAVE_SUCCESS:
        draft.isSavingTemplate = true;
        break;
      case TEMPLATE_SAVE_FAILURE:
        draft.isSavingTemplate = false;
        break;
      // FILTER DATA
      case TEMPLATE_GET_FILTER_DATA:
        draft.isFetchingFilters = true;
        break;
      case TEMPLATE_GET_FILTER_DATA_SUCCESS:
        draft.isFetchingFilters = false;
        draft.filters = { ...draft.filters, ...action.payload };
        break;
      case TEMPLATE_GET_FILTER_DATA_FAILURE:
        draft.isFetchingFilters = false;
        break;
    }
  });
export default emailReducer;
